import React from "react";
import { Alert, Box, Divider, Typography } from "@mui/material";
import EntityForm from "../components/EntityForm";
import UserPhotoBlock from "../components/UserPhotoBlock";
import { createUser } from "../api/coreApi";
import { fkId } from "../utils/coreHelpers";

export default function UserFormStep({
  loading,
  setLoading,
  setErr,
  refreshAll,
  hospitals = [],
  selectedHospitalId,
  setSelectedHospitalId,
  users = [],
  onFinish,
}) {
  if (!hospitals.length) return <Alert severity="info">Create Hospital first (Step 1).</Alert>;

  const hospitalOptions = hospitals.map((h) => ({
    value: fkId(h.hospital_id || h.id),
    label: `${h.name} (${h.city || "-"})`,
  }));

  const onSubmit = async (vals, helpers) => {
    setLoading(true);
    setErr("");

    try {
      const payload = {
        organization: selectedHospitalId,
        full_name: vals.full_name,
        email: vals.email,
        phone: vals.phone,
        status: vals.status,
      };

      await createUser(payload);

      helpers?.reset?.();
      await refreshAll();

      // ✅ Final setup success message in wizard
      onFinish?.();
    } catch (e) {
      setErr(e?.response?.data ? JSON.stringify(e.response.data) : "Create user failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography sx={{ fontWeight: 900, mb: 1 }}>Step 6: User / Staff</Typography>

      <EntityForm
        title="Create User"
        loading={loading}
        initialValues={{
          _hospital: selectedHospitalId || hospitalOptions[0]?.value || "",
          full_name: "",
          email: "",
          phone: "",
          status: "INVITED",
        }}
        fields={[
          {
            name: "_hospital",
            label: "Hospital",
            type: "select",
            required: true,
            options: hospitalOptions,
          },
          { name: "full_name", label: "Full Name", required: true },
          { name: "email", label: "Email", required: true },
          { name: "phone", label: "Phone" },
          {
            name: "status",
            label: "Status",
            type: "select",
            options: [
              { value: "ACTIVE", label: "Active" },
              { value: "INVITED", label: "Invited" },
              { value: "DISABLED", label: "Disabled" },
            ],
          },
        ]}
        onSubmit={(vals, helpers) => {
          if (vals._hospital && vals._hospital !== selectedHospitalId) {
            setSelectedHospitalId(vals._hospital);
          }
          return onSubmit(vals, helpers);
        }}
      />

      <Divider sx={{ my: 2 }} />

      <Typography sx={{ fontWeight: 900, color: "primary.main", mb: 1 }}>
        Upload User Photo
      </Typography>

      <UserPhotoBlock users={users} onDone={refreshAll} />
    </Box>
  );
}